import React, { PureComponent } from 'react';
import { PropTypes } from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { TextInput } from 'components/Common/Inputs';

const isRequired = value => !value || !value.trim();

class PasswordChangeForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired
  };

  render() {
    const {
      handleSubmit,
      id
    } = this.props;
    return (
      <form
        id={ id }
        onSubmit={ values => handleSubmit(values) }
        className="form-horizontal"
      >
        <div className="form-group">
          <div className="col-12 col-sm-12">
            <label
              htmlFor="new-password"
              className="form-label"
            >
              New Password
            </label>
            <Field
              id="new-password"
              name="newPwd"
              component={ TextInput }
              type="password"
              className="form-input"
              placeholder="Enter new Password"
              required
              normalize={ value => value && value.replace(/^[ ]+/g, '') }
              validate={ isRequired }
            />
          </div>
        </div>

        <div className="form-group">
          <div className="col-12 col-sm-12">
            <label
              htmlFor="confirm-password"
              className="form-label"
            >
              Confirm Password
            </label>
            <Field
              id="confirm-password"
              name="confirmPwd"
              component={ TextInput }
              type="password"
              className="form-input"
              placeholder="Confirm Password"
              required
              normalize={ value => value && value.replace(/^[ ]+/g, '') }
              validate={ isRequired }
            />
          </div>
        </div>
        <button
          type="submit"
          id="dummy-add-form-btn"
          className="none"
        >Calculate</button>
      </form>
    );
  }
}

export default reduxForm({
  form: 'pwdChgForm'
})(PasswordChangeForm);
